<!-- 导入展品 -->
<template>
  <div>
    <el-dialog
      class="dialog-import-collect"
      :visible.sync="dialogShow"
      :fullscreen="true"
      :show-close="false"
    >
      <div class="wrap">
        <!-- 头部 -->
        <div class="header">
          <!-- 面包屑 -->
          <el-breadcrumb separator="/">
            <el-breadcrumb-item @click.native="back">
              <span class="breadcmb">{{projectName}}</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>导入展品</el-breadcrumb-item>
          </el-breadcrumb>

          <!-- 已选择 -->
          <h3>
            <svg-icon icon-class="info" style="font-size:13px;"/>
            已选择{{this.selectList.length}}项
            <i class="g-line-split gray ml-20 mr-20"></i>
            <span class="m-btn" @click="clickClear">清空</span>
          </h3>

          <!-- 操作 -->
          <div class="btns">
            <el-button @click="dialogShow=false">取消</el-button>
            <el-button type="primary" @click="add">添加</el-button>
          </div>
        </div>

        <div class="content-box">
          <!-- 侧边栏 -->
          <div class="menu-box fl">
            <!-- <span>我的收藏夹</span> -->
            <li class="el-menu-item el-menu-title" style="padding-left: 20px;">
              <span>我的收藏夹</span>
            </li>
            <sidebar :menuList="sidebarData" :activeIndex="activeIndex" :callFun="handleTab"></sidebar>
          </div>

          <!-- 列表 -->
          <div class="content">
            <div class="collect-list-box">
              <div class="total-box">
                <h3>
                  <strong>{{total}}</strong>件藏品
                </h3>
              </div>
              <h1 class="title">{{centerName}}</h1>
              <h3>
                {{createTime}}创建
                <span
                  class="m-btn fr"
                  @click="allSelect"
                >{{hasAllSelect ? '取消全选': '全选'}}</span>
              </h3>

              <el-row :gutter="30" class="collect-list" v-if="dataList.length > 0 ">
                <el-col
                  :xs="6"
                  :sm="6"
                  :md="6"
                  :xl="4"
                  v-for="item in dataList"
                  :key="item.centerId"
                  @click.native="toggleCheck(item)"
                >
                  <div class="it" :class="{'is-checked': item.active}">
                    <label
                      class="my-checkbox el-checkbox__input"
                      :class="{'is-checked': item.active}"
                    >
                      <span class="el-checkbox__inner"></span>
                    </label>
                    <!-- <img src="~@images/default-pic.svg" alt=""> -->
                    <img :src="item.collectMainImg || ''" alt :onerror="defaultImg">
                    <h4 class="tc ell">{{item.title}}</h4>
                    <!-- <el-checkbox-group v-model="checkList">
                      <el-checkbox label="复选框 A"></el-checkbox>
                      <el-checkbox label="复选框 B"></el-checkbox>
                      <el-checkbox label="复选框 C"></el-checkbox>
                      <el-checkbox label="禁用" disabled></el-checkbox>
                      <el-checkbox label="选中且禁用" disabled></el-checkbox>
                    </el-checkbox-group>-->
                  </div>
                </el-col>
              </el-row>

              <!-- 无数据 -->
              <div class="g-no-data mb-30 mt-30" v-if="dataList.length === 0 && !listLoading">
                <div class="no-data-bg"></div>
                <p class="txt tc">暂无数据</p>
              </div>

              <!-- 分页 -->
              <div class="pagination-container">
                <el-pagination
                  :current-page="listQuery.currentPage"
                  :page-size="listQuery.size"
                  :total="total"
                  background
                  layout="total, prev, pager, next, sizes, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- <cmp-swiper-collect ref="swiperModel"></cmp-swiper-collect> -->
  </div>
</template>

<script>
import sidebar from '@cmp/sidebar'
// import cmpSwiperCollect from '@cmp/swiper-collect'
export default {
  components: {
    sidebar
    // cmpSwiperCollect,
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,

      projectName: this.$route.query.projectName,
      // checkList: ['选中且禁用','复选框 A'],
      dialogShow: false,
      hasAllSelect: false, // 是否已全选
      activeIndex: '',
      centerName: '',
      createTime: '',
      sidebarData: [
        {
          name: '明清书画（20）',
          icon: '',
          index: '/noJump?type=1',
          type: '1'
        },
        {
          name: '明清书画（21）',
          icon: '',
          index: '/noJump?type=2',
          type: '2'
        },
        {
          name: '明清书画（20）',
          icon: '',
          index: '/noJump?type=3',
          type: '3'
        }
      ],
      dataList: [],
      total: 0,
      listLoading: false,
      listQuery: {
        centerId: '',
        currentPage: 1,
        size: 10
      },
      selectList: []
    }
  },
  methods: {
    init() {
      this.projectName = this.$route.query.projectName
      this.dialogShow = true
      this.selectList = []
      this.getCollectData()
    },
    back(){
      this.dialogShow = false
      this.$emit('importCall')
    },
    handleTab(item) {
      this.listQuery.centerId = this.$common.getStrParam(item, 'centerId')
      this.activeIndex =
        '/noJump?centerId=' + this.$common.getStrParam(item, 'centerId')
      this.getDataList()
    },
    // 选择
    toggleCheck(item) {
      if (item.active) {
        let index = this.selectList.findIndex(it => it.id === item.id)
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(item)
      }

      this.$set(item, 'active', !item.active)
    },
    // 全选、取消全选
    allSelect() {
      this.dataList.forEach(item => {
        this.$set(item, 'active', !this.hasAllSelect)
      })
      this.hasAllSelect = !this.hasAllSelect
      this.selectList = this.hasAllSelect
        ? JSON.parse(JSON.stringify(this.dataList))
        : []
    },
    // 清空
    clickClear() {
      this.dataList.forEach(item => {
        this.$set(item, 'active', false)
      })
      this.hasAllSelect = false
      this.selectList = []
    },
    // 藏品详情 暂不要
    // showDetail() {
    //   this.$refs.swiperModel.init()
    // },
    // 批量添加
    add() {
      if (!this.selectList.length) {
        this.$message({
          message: '请选择藏品',
          type: 'warning'
        })
        return
      }

      let collectIds = []
      this.selectList.forEach(item => {
        collectIds.push(item.collectId)
      })
      this.$http
        .post('/exhibits/batchSaveExhibits', {
          collectIds: collectIds,
          projectId: this.$route.query.projectId
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.dialogShow = false
            this.clickClear()
            this.$emit('importCall')
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 查询收藏夹
    getCollectData() {
      this.sidebarData = []
      this.$http.get('/collection/getCollectCenterList', {}).then(res => {
        if (res.success) {
          res.result.forEach(item => {
            this.sidebarData.push({
              name: item.centerName + '（' + item.collectNum + '）',
              icon: '',
              index: '/noJump?centerId=' + item.centerId,
              centerId: item.centerId,
              collectNum: item.collectNum
            })
          })
          if (this.sidebarData.length > 0) {
            this.listQuery.centerId = this.sidebarData[0].centerId
            this.activeIndex =
              '/noJump?centerId=' + this.sidebarData[0].centerId
            this.getDataList()
          } else {
            this.listLoading = false
            this.dataList = []
            this.total = 0
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDataList() {
      this.listLoading = true
      this.$http
        .get('/collection/getCollectListByCenterWithPage', {
          ...this.listQuery
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.centerName = res.result.centerName
            this.createTime = res.result.createTime
            this.dataList = res.result.collectList
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getDataList()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-import-collect {
  .wrap {
    min-width: $minWidth;
  }
  .header {
    padding: 0 30px;
    margin-bottom: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    line-height: 60px;
    background-color: #fff;
    /deep/ .el-breadcrumb {
      font-size: 16px;
      margin-bottom: 0;
    }
    /deep/ .el-breadcrumb__inner.is-link {
      font-weight: normal;
    }
    .breadcmb {
      color: $color5 !important;
      cursor: pointer !important;
    }
    h3 {
      padding-left: 50px;
      flex: 1;
    }
  }
  .content-box {
    padding: $paddingWidth;
    .menu-box {
      /deep/ .el-menu {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      /deep/ .el-menu-item {
        padding-left: 35px !important;
      }
      .el-menu-title.el-menu-item {
        padding-left: 40px !important;
        font-size: 18px;
        color: $color5;
        font-weight: bold;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
    }
    .content {
      padding-left: 180px;
      .collect-list-box {
        position: relative;
        padding: $paddingWidth;
        border-radius: 4px;
        background-color: #fff;
        .title {
          margin-bottom: 20px;
          height: 24px;
        }
        .total-box {
          position: absolute;
          right: 30px;
          top: 30px;
          strong {
            font-size: 30px;
            color: $color5;
          }
        }
        .collect-list {
          margin-top: 30px;
          .it {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            position: relative;
            padding: 35px;
            margin-bottom: 30px;
            cursor: pointer;
            border-radius: 4px;
            border: 2px solid transparent;
            &.is-checked {
              border: 2px solid $primary;
            }
            &:hover {
              background: $color3;
            }
            .my-checkbox {
              position: absolute;
              top: 10px;
              left: 10px;
            }
            img {
              width: 92px;
              height: 92px;
            }
            h4 {
              width: 115px;
              // position: absolute;
              // left: 25px;
              // bottom: 0;
              line-height: 35px;
            }
          }
        }
      }
    }
  }
  /deep/ .el-dialog {
    padding: 0;
    background-color: #f2f3f8;
  }
  /deep/ .el-dialog__header {
    display: none;
  }
}
</style>


